import _ from 'lodash';
import React, {useContext} from 'react';

import {makeSafeForUrl} from '../../../../ducks/data-url-helpers';
import {getClosestFk, unwrapNullableDataType} from '../../../../ducks/formattersettingshelpers';
import {InternalNavLink} from '../../../../ui-toolkit';
import SitemapContext from '../../../SitemapContext';

/**
 * Show a link to the detail page of referenced entity next to it on the card
 * @param dataType The data type of the field
 * @param entity The entity that is referenced
 * @param t translation function
 * @returns {React.JSX.Element|null}
 */
export function FKLink({path, entity, t}) {
    const sitemap = useContext(SitemapContext);
    if (entity == null) return null;

    const closestFkAttr = getClosestFk(path);
    if (!closestFkAttr) return null; // There is no FK in the path

    const fkType = unwrapNullableDataType(closestFkAttr.finalAttribute.dataType);

    const fkEntity = _.get(entity, closestFkAttr.pathName + '.entityId');
    if (!fkEntity) return null; // The FK is missing, so can't link

    if (
        !_.some(sitemap.links, (link) => link.type === 'detail' && link.props.entityTypeId === fkType.entityDataTypeId)
    ) {
        // user doesn't have read access to this, so don't render link
        return null;
    }

    const urlSafeName = makeSafeForUrl(fkType.entityDataType.dataTypeName);

    return (
        <InternalNavLink color="primary" link="true" to={`/data/${urlSafeName}/detail/${fkEntity}`}>
            {t('nav.viewDetail')}
        </InternalNavLink>
    );
}
